import { Plus } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

export default function UseCases() {
  const { t } = useLang();
  const cards = t("usecases.cards");
  return (
    <section data-testid="usecases-section" className="bg-mist text-ink py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.25em] text-dblue">{t("usecases.eyebrow")}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl">{t("usecases.title")}</h2>
        </Reveal>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.07}>
              <div className="h-full rounded-2xl border border-ink/10 bg-white p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-dblue/40 hover:shadow-[0_18px_45px_-20px_rgba(20,110,245,0.35)]">
                <p className="font-display text-sm font-extrabold tracking-wide">{c.title}</p>
                <div className="mt-4 space-y-2">
                  {c.items.map((item, k) => (
                    <div key={item} className="flex items-center gap-2 text-sm text-slate-600">
                      {k > 0 && <Plus className="h-3 w-3 text-dblue shrink-0" />}
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
